import { renderRevision } from '../../../../shared/helpers/renderLocator';
import { ExceptionIgnoreScope } from '../../../../shared/issuesV2';
import type { ExceptionPackageScope } from '../../../../shared/issuesV2';
import type { LocatorParts } from '../../../../shared/Locator';

/**
 * Provides a human readable version, taking into account package scoping
 * @param packageScope {ExceptionPackageScope} Package scoping
 * @param revision {LocatorParts} Revision with version
 * @returns {string} 'All' or human readable version (linux parsed)
 */
export const getHumanReadableVersion = (packageScope: ExceptionPackageScope, revision: LocatorParts | null) =>
  packageScope === 'ALL_VERSIONS' || !revision?.revision ? 'All' : renderRevision(revision);

const scopeToBadgeText: Record<ExceptionIgnoreScope, Uppercase<string>> = {
  [ExceptionIgnoreScope.Project]: 'PROJECT',
  [ExceptionIgnoreScope.ProjectAndReleaseGroups]: 'PROJ + RG',
  [ExceptionIgnoreScope.ReleaseGroup]: 'RELEASE GROUP',
  [ExceptionIgnoreScope.Policy]: 'POLICY',
  [ExceptionIgnoreScope.Organization]: 'GLOBAL',
};

/**
 * Provides a human readable ignore scope
 * @param {ExceptionIgnoreScope} ignoreScope Ignore scope for the exception
 */
export const getBadgeTextForIgnoreScope = (ignoreScope: ExceptionIgnoreScope) => scopeToBadgeText[ignoreScope] || 'UNKNOWN';
